import React from 'react';
import styles from './SilentPicker.module.scss';
import { SilentPickerProps } from './types';
import { useSilentPicker } from './useSilentPicker';
import { PickerTrigger } from './PickerTrigger';
import { PickerPopover } from './PickerPopover';

export default function SilentPicker({
  id,
  label,
  items,
  selectedKey,
  onSelectionChange,
  isDisabled = false,
  isRequired = false,
  necessityIndicator,
  placeholder = 'All',
  'aria-label': ariaLabel,
  width,
  isQuiet = true
}: SilentPickerProps) {
  const {
    isOpen,
    focusedIndex,
    popoverStyle,
    triggerRef,
    listboxRef,
    selectedItem,
    handleToggle,
    handleSelect,
    handleKeyDown,
    handleItemKeyDown
  } = useSilentPicker({
    items,
    selectedKey,
    onSelectionChange,
    isDisabled
  });

  const pickerId = id;
  const listboxId = `${pickerId}-listbox`;

  return (
    <div
      className={`${styles['spectrum-picker']} ${
        isDisabled ? styles['is-disabled'] : ''
      } ${isQuiet ? styles['spectrum-picker--quiet'] : ''}`}
      style={{ width }}
    >
      <div>
        <PickerTrigger
          pickerId={pickerId}
          listboxId={listboxId}
          isOpen={isOpen}
          isQuiet={isQuiet}
          isDisabled={isDisabled}
          selectedItem={selectedItem}
          placeholder={placeholder}
          label={label}
          ariaLabel={ariaLabel}
          triggerRef={triggerRef}
          onToggle={handleToggle}
          onKeyDown={handleKeyDown}
        />

        {isOpen && (
          <PickerPopover
            items={items}
            selectedKey={selectedKey}
            focusedIndex={focusedIndex}
            pickerId={pickerId}
            label={label}
            popoverStyle={popoverStyle}
            listboxRef={listboxRef}
            onSelect={handleSelect}
            onItemKeyDown={handleItemKeyDown}
          />
        )}
      </div>
    </div>
  );
}
